import { HeroSource } from '@profile/src/models';
export const options = [{
  label: 'Open Box',
  id: HeroSource.OPEN_BOX
}, {
  label: 'Sold',
  id: HeroSource.SOLD
}, {
  label: 'Purchase',
  id: HeroSource.PURCHASE
}, {
  label: 'Non-NFT Shop',
  id: HeroSource.NON_NFT_SHOP
}, {
  label: 'Fusion-Product',
  id: HeroSource.FUSION_PRODUCT
}];